<template>
<div class="order">
<!--

   -->
<el-row>
  <el-col :span="14" :offset="5"><div class="order_content">
<h3>个人订单</h3>
<div class="order_dan">
  <el-table
  height="250"
      :data="getInfo"
      style="width: 100%">
      <el-table-column
        prop="status"
        label="订单状态"
        width="180">
      </el-table-column>
      <el-table-column
        prop="order_id"
        label="订单号">
      </el-table-column>
      <el-table-column
        prop="total_amount"
        label="订单金额"
        width="180">
      </el-table-column>

    </el-table>
    </div>
</div></el-col>
</el-row>
</div>
</template>

<script>
export default{
  data(){
    return {
    }
  },
  created() {
this.order();
// console.log(this.getInfo)
  },
  computed:{
getInfo () {
      return this.$store.state.InfoModule.getInfo;
    }
  },
  methods:{
    order() {
      let token = this.$cookie.get('token')
      this.$store.dispatch('getInfoOrder',token)
    }
  },
}
</script>

<style lang="scss">
.order{
  height: 85vh;
  width: 100%;
  background-color: #FFFFFF;
  .order_content {
    height: 9rem;
    background-color: #f5f8fa;
    border-radius: 10px;
    margin-top: 1rem;
    overflow: hidden;
    h3 {
      margin-bottom: 0.5rem;
      margin-top: 0.5rem;
      font-size: 20px;
      color: blue;
    }
    .order_dan {
      width: 95%;
      margin: 0px auto;
    }
  }
}
</style>
